<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :items-per-page="-1"
      disable-sort
      dense
      hideDefaultFooter
    >
      <template v-slot:[`item.valor_servicos`]="{ item }">
        {{ toReal(item.valor_servicos) || toReal(0) }}
      </template>
      <template
        v-for="header in headers.filter((header) => header.servico)"
        v-slot:[`item.${header.value}`]="{ item }"
      >
        <div v-bind:key="header.value" class="d-flex flex-column">
          <span class="">
            {{ toReal(header.value in item ? item[header.value].valor : 0) }}
          </span>
          <span class="">
            N° Cms
            {{ header.value in item ? item[header.value].quantidade : 0 }}
          </span>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { toReal } from '@/mixins/convertion.js'
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [toReal],
  data() {
    return {}
  },
  computed: {
    headers() {
      if (Object.keys(this.data).length > 0) {
        let _headers = [{ text: 'Mês', value: 'mes' }]
        this.data.headers.forEach((item) =>
          _headers.push({ text: item, value: item, servico: true })
        )
        _headers.push({ text: 'Total Caminhões', value: 'triados' })
        _headers.push({ text: 'Total Serviços', value: 'total_servicos' })
        _headers.push({ text: 'Valor Serviços', value: 'valor_servicos' })
        return _headers
      } else {
        return []
      }
    },
    items() {
      if (Object.keys(this.data).length > 0) {
        let _items = []
        _items = Object.values(this.data.meses).map((item) => {
          return {
            mes: item.mes,
            triados: item.agendamentos?.triados,
            total_servicos: item.servicos.detalhes.total,
            valor_servicos: item.servicos.detalhes.valor,
            ...item.servicos.detalhes.items,
          }
        })
        return _items
      }
      return []
    },
  },
  methods: {},
}
</script>
